$(document).foundation();
$(document).ready(function () {
	// utils
	initVerticalCenter();
	initAnimateInView();
	inlineSVGs([
		//'.home__wave',
		'.footer__social img'
	]);
	initFileUpload();
	
	// global
	initHeader();
	initFooter();
	initSliders();
	initAccordions();
	initMaps();
	initOffCanvas();
	initPopup();
	initForms();
	
	// template specific
	initHome();
	initSeasonalLanding();
	initSeasonalDetail();
	initCareersLanding();
	initAnchors();
	initGallery();
	initPlainText();
	initOffersFilter();
	initOffersPage();
	initHideHeader();
	// customCookieBar();
});

function initHideHeader() {
	if (window.location.href.indexOf("accommodation/packages") !== -1) {
		// Hide the component with the class "header"
		$(".header").hide();
	}
}

function initOffCanvas() {
	//$('#offCanvas').foundation('open');

	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});


	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});

	var navItems = $('.off-canvas__nav-primary > ul > li > ul');
	navItems.each(function() {
		$(this).parent().addClass('arrow');
	})
}





function initVerticalCenter() {
	$('.vertical-center').each(function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
	var selectorString = '';
	if (typeof inputValue === "object") {
		selectorString = inputValue.join(',');
	} else {
		selectorString = inputValue;
	}

	$(selectorString).each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		
		if (imgURL.indexOf('.svg') > -1) {
			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
	
				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
	
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
	
				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}
	
				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		}
	});
}



function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

	var viewportWidth, viewportHeight;
	if (scaleToParent) {
		viewportWidth = $(element).parent().innerWidth();
		viewportHeight = $(element).parent().innerHeight();
	} else {
		viewportWidth = $(window).innerWidth();
		viewportHeight = $(window).innerHeight();
	}

	var $element = $(element);

	var elementWidth = $element.attr('width');
	var elementHeight = $element.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = elementHeight / elementWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (elementWidth / elementHeight) * viewportHeight
	var newHeight = (elementHeight / elementWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$element.css('height', viewportHeight);
		$element.css('width', newWidth);
		$element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$element.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$element.css('width', viewportWidth);
		$element.css('height', newHeight);
		$element.css('left', '0');
		$element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$element.css('height', viewportHeight);
		$element.css('width', viewportWidth);
		$element.css('left', '0');
		$element.css('top', '0');
	}
}



function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
	$(window).on('scroll', handleInView);
	handleInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		if ( $(this).hasClass('in-view') ) {
			return;	
		}
		
		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;
			
			$(elementToAnimate).addClass('in-view'); // log that this element has been seen
			
			
			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);
			
			
			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function handleInView() {
	$('[data-remove-class]').each(function () {
		if ( $(this).hasClass('in-view') ) return;
		if (isElementInViewport($(this))) {
			var elementToAnimate = $(this);
			elementToAnimate.addClass('in-view')
			setTimeout(function () {
				elementToAnimate.removeClass(elementToAnimate.data('remove-class') ); 
			}, 500);
		}
	})
}




function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}
	
	var rect = el.getBoundingClientRect();
	
	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;
	
	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}




var initHeader = function () {
	
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;
	
		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}

	// Detect if the header is over and image slider, if yes then give it a transparent background
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);

	function setHeaderTransparency() {
		if (window.pageYOffset > (window.innerHeight / 2) ) {
			$('.header').removeClass('header--transparent').addClass('header--compact');
			$('.header__book .button').removeClass('button--white').addClass('button--autumn');
		} else {
			$('.header').removeClass('header--compact');
			
			if ( $('.slider').length > 0 ) {
				$('.header').addClass('header--transparent');
				$('.header__book .button').removeClass('button--autumn').addClass('button--white');
			} else {
				$('.header__book .button').removeClass('button--white').addClass('button--autumn');
			}
		}
	}
	
	
	
	$('.header__lang-button').on('click', function () {
		$('.header__lang-switcher').toggleClass('open');
	});
}






function initFooter()  {
	$('.footer__nav a, .off-canvas__nav-footer a').each(function () {
		if ( $(this).text() == 'FAQs' ) {
			$(this).css('text-transform', 'none');
		}
	});
}




function initSliders() {
	$('.slider__inner').slick({
		autoplay: true,
		fade: true,
		autoplaySpeed: 6500,
		speed: 1000,
		arrows: false,
		dots: false,
		pauseOnHover: false
	});

	if ( $('.slider, .directions-map').length === 0 ) {
		pushContentBelowHeader()
		$(window).on('resize', pushContentBelowHeader);
	} else {
		$('body').addClass('has-slider');
	}
	
	if ($('.slider__video').length > 0) {
		// Make sure the slider always fills the whole screen
		coverViewport($('.slider__video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__video iframe'), true);
		});
	}
	
	$('.slider__scroll button').on('click', function () {
		$('html, body').animate({
			scrollTop: $('.slider').outerHeight() - $('.header').outerHeight()
		}, 1000);
		
		return false;
	});
	
	
	$('.accommodation__slider-inner, .careers__item-slider-inner').
	each(function() {
		$(this).slick({
		arrows: true,
		fade: true,
		speed: 750,
		dots: true,
		appendDots: '.careers__item-arrows',
		appendArrows: '.careers__item-arrows', 
	})
	});
	
	$('.accommodation__promo-slider-inner').slick({
		arrows: true, 
		dots: true, 
		fade: true,
		speed: 750,
		prevArrow: '<span class="slick-prev"></span>', 
		nextArrow: '<span class="slick-next"></span>', 
		appendArrows: '.accommodation__promo-slider .slider-nav', 
		appendDots: '.accommodation__promo-slider .slider-nav'
	});
	
	
	$('.home__promo-slider-inner').slick({
		arrows: true, 
		dots: true, 
		fade: true,
		speed: 750,
		prevArrow: '<span class="slick-prev"></span>', 
		nextArrow: '<span class="slick-next"></span>', 
		appendArrows: '.home__promo-slider .slider-nav', 
		appendDots: '.home__promo-slider .slider-nav'
	});
	
	
	
	
	
	$('.other-rooms').each(function () {
		var slidesToShow;
		
		if ( $(this).find('.other-rooms__room').length > 3 ) {
			$(this).addClass('other-rooms--center-mode');			
		}
		
		if ( $(this).find('.other-rooms__room').length >= 3 ) {
			$(window).on('resize', alignOtherRoomsArrows);
			$(this).find('.other-rooms__carousel').on('init', alignOtherRoomsArrows);
			Foundation.onImagesLoaded($(this).find('img'), alignOtherRoomsArrows);
						
			slidesToShow = 3;
		} else {
			slidesToShow = 2;
		}
		
		if ( $(this).find('.other-rooms__room').length > 1 ) {
			$(this).find('.other-rooms__carousel').slick({
				slidesToShow: slidesToShow,
				centerMode: true,
				centerPadding: 0,
				arrows: true,
				infinite: true,
				speed: 750,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1,
							dots: true
						}
					}
				]
			});
		} else {
			$(this).addClass('other-rooms--single');
		}
	});
	
	
	
	$('.offers-carousel__inner').slick({
		arrows: true,
		dots: true,
		speed: 750
	});
}

function alignOtherRoomsArrows() {
	var topValue = $('.other-rooms__image').first().outerHeight() / 2 + 14;
	$('.other-rooms .slick-arrow').css('top', topValue + 'px');
}



function pushContentBelowHeader() {
	$('main').css('padding-top', $('.header').outerHeight() + 'px');
}



function initAccordions() {
	$('.accordion').accordiom({
		showFirstItem: false
	});
}


function initMaps() {
	var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;;
	
	$('[data-map]').each(function () { 
		var mapStyle=[{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#291e45"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f5ece3"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{lightness:"-22"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{saturation:"11"},{lightness:"-51"}]},{featureType:"road.highway",elementType:"labels.text",stylers:[{saturation:"3"},{lightness:"-56"},{weight:"2.20"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{lightness:"-52"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{weight:"6.13"}]},{featureType:"road.highway",elementType:"labels.icon",stylers:[{lightness:"-10"},{gamma:"0.94"},{weight:"1.24"},{saturation:"-100"},{visibility:"off"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{lightness:"-16"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{saturation:"-41"},{lightness:"-41"}]},{featureType:"road.arterial",elementType:"labels.text.stroke",stylers:[{weight:"5.46"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry.fill",stylers:[{weight:"0.72"},{lightness:"-16"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{lightness:"-37"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#8ccac4"},{visibility:"on"}]}];
		
		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
			
			if ( ($('body').innerWidth() <= 640) && (typeof $(this).data('map-marker-coords') != 'undefined') ) {
				centerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				centerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			}
		} else {
			centerLat = 0;
			centerLng = 0;
		}
		
		zoom = $(this).data('map-zoom') || 8;
		
		map = new google.maps.Map($(this)[0], {
			center: {lat: centerLat, lng: centerLng},
			zoom: zoom,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			
			styles: mapStyle
		});
		
		

		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});
			
			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}
		
		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});
			
			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});
		
		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));
			
			var directionsTo = $(this).data('map-directions-destination') || 'The Headland, Fistral Beach, Headland Rd, Newquay, Cornwall TR7 1EW';
			
			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};
				
				directionsService.route(directionsRequest, function(result, status){        
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});
				
				return false;
			});
		}
	});
	
	
	if ( $('.directions-map').length > 0 ) {
		var urlParams = new URLSearchParams(window.location.search);
		var locationParam = urlParams.get('location');
		
		if ( locationParam !== null ) {
			if ( locationParam !== '' ) {
				$('#tbPostcode').val(locationParam);
				
				var directionsService  = new google.maps.DirectionsService();
				var directionsRenderer = new google.maps.DirectionsRenderer();
				directionsRenderer.setMap(map);
				directionsRenderer.setPanel($('#map-directions-data').get(0));
				
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsTo = $('.directions-map .map-container').data('map-directions-destination');
				
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};
				
				directionsService.route(directionsRequest, function(result, status){        
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});
			}
		}
	}
}



function initSeasonalLanding() {
	if ( $('body').hasClass('template-seasonal-landing') ) {
		arrangeSeasonalLanding();
		
		$('.seasonal-landing').on('filter-changed', function () {
			setTimeout(function () {
				arrangeSeasonalLanding();
			}, 550);
		});
		
		var beenFiltered = false;
		$('.seasonal-landing__filters button').on('click', function () {
			if (!beenFiltered) {
				beenFiltered = true;
				$('.seasonal-landing__image, .seasonal-landing__content').each(function () {
					$(this).addClass( $(this).data('animate-in-view') );
				});
			}
		});
		
		
		if ( $('body').hasClass('theme-spring-summer') ) {
			$('.seasonal-landing__grid .button').addClass('button--summer-winter-hover');
			
			$('.offers-carousel .text-button').removeClass('text-button--autumn').addClass('text-button--summer');
			$('.offers-carousel__cta .button').removeClass('button--autumn').addClass('button--summer-outline');
		}
		else if ( $('body').hasClass('theme-autumn-winter') ) {
			$('.seasonal-landing__grid .button').addClass('button--white-winter-hover');
			$('.offers-carousel .text-button').removeClass('text-button--autumn').addClass('text-button--summer');
			$('.offers-carousel__cta .button').removeClass('button--autumn').addClass('button--summer-outline');
		}
		
		scaleHomeWave();
		Foundation.onImagesLoaded($('.seasonal-landing__image img'), scaleHomeWave);
		$(window).on('resize', function () {
			setTimeout(function () {
				scaleHomeWave();
			}, 400);
		});
		
		rideTheHomeWave();
		setInterval(rideTheHomeWave, 300);
	}
}

function arrangeSeasonalLanding() {
	$('.seasonal-landing__item').removeClass('visibly-odd visibly-even');
	$('.seasonal-landing__item:visible').even().addClass('visibly-odd');
	$('.seasonal-landing__item:visible').odd().addClass('visibly-even');
	
	if ( $('.seasonal-landing__item').last().hasClass('visibly-even') ) {
		$('.seasonal-landing__grid').addClass('extra-padding');
	} else {
		$('.seasonal-landing__grid').removeClass('extra-padding');
	}
}



function initHome() {
	if ( $('body').hasClass('template-home') ) {
		// Set the correct colour for the top part of the page
		if ( $('.home__season').first().hasClass('home__season--spring') ) {
			$('.home').addClass('home--spring-first');
		} else if ( $('.home__season').first().hasClass('home__season--summer') ) {
			$('.home').addClass('home--summer-first');
		} else if ( $('.home__season').first().hasClass('home__season--autumn') ) {
			$('.home').addClass('home--autumn-first');
		} else if ( $('.home__season').first().hasClass('home__season--winter') ) {
			$('.home').addClass('home--winter-first');
		}
		
		// $(window).on('DOMContentLoaded load resize scroll', animateHomeSeasons);
		// animateHomeSeasons();
		
		scaleHomeWave();
		Foundation.onImagesLoaded($('.home img'), scaleHomeWave);
		$(window).on('resize', function () {
			setTimeout(function () {
				scaleHomeWave();
			}, 400);
		});
		
		rideTheHomeWave();
		setInterval(rideTheHomeWave, 300);

	}
}

function animateHomeSeasons() {
	$('.home__item').removeClass('hidden');
}

function scaleHomeWave() {
	// Scale the wave so that it always fits inside the homepage
	// and ends at the right spot on the map
	
	// Set these based on the wave.svg file
	var waveWidth  = 970;
	var waveHeight = 5245;
	var waveEndWidth = 532; // (266 * 2)
	
	// Set these based on the home-map.svg file
	var mapWidth  = 1366;
	var mapHeight = 724;
	var mapPointX = 970;
	var mapPointY = 186;
	var mapPointWidth = 574; // (287 * 2)
	
	// Dynamic sizes
	var homeHeight = $('.home').outerHeight();
	
	if ( $('body').hasClass('template-seasonal-landing') ) {
		homeHeight = $('main').outerHeight();
	}
	
	var windowScaleX = $('body').innerWidth() / mapWidth; //def right way round
	mapPointWidth = mapPointWidth * windowScaleX;
	
	mapHeight = mapHeight  * windowScaleX;
	mapPointY = mapPointY * windowScaleX;
	
	// Now calculate how much to scale the wave
	var waveScaleX = mapPointWidth / waveEndWidth;
	var waveScaleY = (homeHeight - ( mapHeight - mapPointY ) ) / waveHeight;
		
	var scrollBarAllowance = (window.innerWidth - $('body').innerWidth()) / 2;
	$('.home__wave svg').attr('style', 'transform: scale(' + waveScaleX + ',' + waveScaleY + ') translate(' + scrollBarAllowance + 'px, -10px)');
}

function rideTheHomeWave() {
	// Draw the wave as the user scrolls down the page
	
	var homeWaveSvg = $('.home__wave svg')[0];
	
	if (homeWaveSvg !== null && homeWaveSvg !== undefined) {
		
		var waveScale = 5245 / homeWaveSvg.getBoundingClientRect().height;
		var scrollPoint = window.pageYOffset * 1.3;
		
		var x = homeWaveSvg.querySelector('#WavePath').getPointAtLength(scrollPoint).x - 485;
		var y = homeWaveSvg.querySelector('#WavePath').getPointAtLength(scrollPoint).y;
		
		var maskScale = (window.pageYOffset - (window.innerHeight / 3.5)) /  homeWaveSvg.outerHeight;
		$('.home__wave svg #wave-mask rect').css('transform', 'scaleY(' + maskScale + ')' );
	}
}

// https://stackoverflow.com/questions/27078285/simple-throttle-in-javascript
function throttle (callback, limit) {
	var waiting = false;                      // Initially, we're not waiting
	return function () {                      // We return a throttled function
		if (!waiting) {                       // If we're not waiting
			callback.apply(this, arguments);  // Execute users function
			waiting = true;                   // Prevent future invocations
			setTimeout(function () {          // After a period of time
				waiting = false;              // And allow future invocations
			}, limit);
		}
	}
}


function initFileUpload() {
	$('.form__file-upload input[type="file"]').on('change', function () {
		
		var attachedFiles = $(this)[0].files;
		
		if ( typeof attachedFiles !== 'undefined' ) {
			var fileNames = '';
			for (var i = 0; i < attachedFiles.length; i++) {
				fileNames += attachedFiles[i].name + '<br />';
			}
			$('#form__file-upload-attachments').html('Attached: <br />' + fileNames);
		}
	});
}


function initPopup() {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		// Only show the popup if the cookie has not been seen, or always show it for testing in either local or remote markup
		if ( 
			(!Cookies.get('hasSeenPopup')) || 
			(location.hostname.indexOf('localhost') > -1) || 
			(location.hostname.indexOf('projects') > -1) 
		) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}
}

// function customCookieBar() {
//     if ( $('.cookies-bar').length > 0 ) {
		
//         if ( !Cookies.get('accepted_cookies') ) {
//             $('.cookies-bar').fadeIn();
//         }
        
//         $('#cookie-bar--accept').on('click', function () {
//             Cookies.set('accepted_cookies', 'true', {expires: $('#cookies-bar').data('notice-keep-hidden-for-n-days')});
//             $('.cookies-bar').css('display', 'none');
//         });

// 		$('#cookie-bar--reject').on('click', function () {
//             Cookies.set('accepted_cookies', 'false', {expires: $('#cookies-bar').data('notice-keep-hidden-for-n-days')});
//             $('.cookies-bar').css('display', 'none')
//         });
//     }
// }


function initForms() {
	setDobOptions() 
	handleIntererests()
	handleWhatYouLike()
	handleFooterDropdowns()
	$('.form .custom-select select').selectric();
	$('.year-dob, .month-dob, .day-dob').selectric()


	function setDobOptions() {
		var day = $(".day-dob");
		for (i = 1; i < 32; i++) {
		  day.append("<option value = " + i + ">" + i + "</option>");
		}
		var month = $(".month-dob");
		for (j = 1; j < 13; j++) {
		  month.append("<option value = " + j + ">" + j + "</option>");
		}
		var date = new Date();
		var cYear = date.getFullYear();

		var year = $(".year-dob");
		var currentYear = new Date().getFullYear()
		for (j = currentYear; j >= 1930; j--) {
		  year.append("<option value = " + j + ">" + j + "</option>");
		}
	  }

	function handleIntererests() {
		var button = $('.interests__button')
		var inputs = $('.interests__dropdown input')
	
		button.on('click', function () {
			$(this).parent().toggleClass('open')
			$('.what-you-like').removeClass('open')
		})

		function updateButton() {
			var labelTexts = inputs.filter(':checked').map(function () {
			  return $(this).siblings('label').text();
			}).get();
			if (labelTexts.length > 0) {
			  button.text(labelTexts.join(', '));
			} else {
			  button.text('Tell us what you want to hear about the Headlands?');
			}
		  }


		inputs.on('change', function () {
		updateButton();
		});
	} 

	function handleWhatYouLike() {
		var button = $('.what-you-like__button')
		var inputs = $('.what-you-like__dropdown input')

		button.on('click', function () {
			$(this).parent().toggleClass('open')
			$('.interests').removeClass('open')
		})

		function updateButton() {
			var labelTexts = inputs.filter(':checked').map(function () {
			  return $(this).siblings('label').text();
			}).get();
			if (labelTexts.length > 0) {
			  button.text(labelTexts.join(', '));
			} else {
			  button.text('Select What You Like');
			}
		}

		inputs.on('change', function () {
			updateButton();
		});
	}
	
	function handleFooterDropdowns() {
		var button = $('.footer-interests__button')
		var inputs = $('.footer-interests__dropdown')

		button.on('click', function(){
			$(this).parent().toggleClass('open')
			inputs.toggleClass('open')
		})

		function updateButton() {
			var labelTexts = inputs.filter(':checked').map(function () {
			  return $(this).siblings('label').text();
			}).get();
			if (labelTexts.length > 0) {
			  button.text(labelTexts.join(', '));
			} else {
			  button.text('Tell us what you want to hear about the Headlands?');
			}
		  }
	}
}


function initSeasonalDetail() {
	$('.seasonal-detail__quote').each(function () {
		var firstQuoteText = $(this).find('p').first().text();
		if ( (firstQuoteText.indexOf('"') === 0) || (firstQuoteText.indexOf('“') === 0) ) {
			$(this).addClass('outdent-quote');
		}
	});
}


function initCareersLanding() {
	var evenOdd = 1;
	$('.careers__positions h2 a').each(function () {
		if ( $(this).attr('name') !== 'undefined' ) {
			$('.careers__anchors-buttons').append('<a class="button button--white-background" href="#' + $(this).attr('name') + '"><div>' + $(this).attr('name') + '</div></a>')
		}
		
		if ( $(this).find('.careers__item-slider').length > 0 ) {
			if (evenOdd < 0) {
				$(this).addClass('careers__item--slider-right');
			}
			evenOdd = evenOdd * -1;
		}
	})
}



function initAnchors() {
	// Generate the mobile dropdown
	var anchorDropdown = '<select><option value="">Jump to...</option>';
	$('.anchors a').each(function () {
		anchorDropdown += '<option>' + $(this).text() + '</option>';
	});
	anchorDropdown += '</select>';
	
	$('.careers__anchors-dropdown').append(anchorDropdown);
	$('.careers__anchors-dropdown select').selectric();
	$('.careers__anchors-dropdown select').on('change', function () {
		var selectVal = $(this).val();
		
		$('.careers__anchors .button').each(function () {
			if ( $(this).text() === selectVal ) {
				$(this).trigger('click');
			}
		})
	})
	
	// Clickable anchors
	$('.anchors a').on('click', function (e) {
		e.preventDefault();
		
		var anchorName = $(this).attr('href').replace('#', '');
		
		// Need to complete all animations before scrolling position can be found
		$('[data-animate-in-view]').each(function () {
			//$(this).addClass( $(this).data('animate-in-view') );
			$(this).addClass('transition--none').removeClass('transform--will-slide-in transform--will-slide-in-right transform--will-fade-in transform--will-fade-up transform--will-fade-down transform--will-fade-left transform--will-fade-right');
		});
		
		var scrollToPos = $('a[name="' + anchorName + '"]').offset().top;
				
		if (typeof scrollToPos !== 'undefined') {
			scrollToPos -= $('.header').outerHeight();
			scrollToPos -= 40;
			
			$('html, body').animate({
				scrollTop: scrollToPos
			}, 1000);
		}
	});
	
	
	
	
	// Nicely scroll if deep linked to an anchor
	if ( window.location.hash !== '' ) {
		$('.anchors a[href="' + window.location.hash + '"]').trigger('click');
		
		$('[data-animate-in-view]').each(function () {
			$(this).addClass( $(this).data('animate-in-view') );
		});
		
		var anchorName = window.location.hash.replace('#', '');
		anchorName = anchorName.replace('%20', ' ');
		if ( $('a[name="' + anchorName + '"]').length === 0 ) {
			return;
		}
		
		// Delay to allow for scrolling animations
		var waitForAnimations = 1500;
		if ( $('.contact__details').length > 0 ) {
			waitForAnimations = 0;
		}
		
		setTimeout(function () {
			var scrollToPos = $('a[name="' + anchorName + '"]').first().parent().offset().top;
			
			if (typeof scrollToPos !== 'undefined') {
				scrollToPos -= $('.header').outerHeight();
				//scrollToPos += 100;
			
			
				$('html, body').animate({
					scrollTop: scrollToPos
				}, 0);
			}
		}, waitForAnimations);
	}
}



function initGallery () {
	$('.filter-controls-dropdown select').selectric();
	
	$('.gallery__item a').on('click', function () {
		var $clickedThumbnail = $(this);
		
		
		
		// Dynamically load the gallery slider into a reveal popup	
		var modal = '<div id="gallery__modal" class="gallery__modal full reveal loading" data-reveal><div class="gallery__modal-image"><button class="gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"><button class="gallery__modal-prev">Previous</button><button class="gallery__modal-next">Next</button></div><div class="gallery__modal-content grid-x"><div class="gallery__modal-caption cell small-12 medium-6">{{caption}}</div><div class="gallery__modal-cta cell small-12 medium-6">{{cta}}</div></div></div>';
		
		modal = modal.replace('{{src}}', $(this).attr('href'));
		modal = modal.replace('{{caption}}', $(this).data('title') || '');
		
		var cta = $(this).data('description') || '';
		if ( ( typeof $(this).data('book-link') !== 'undefined' ) && ( $(this).data('book-link') !== '' ) ) {
			cta += '<a href="' + $(this).data('book-link') + '" class="button" target="_blank">' + ($(this).data('book-title') || 'Book Now') + '</a>';
		}
		modal = modal.replace('{{cta}}', cta);
		
		var $modal = modal;
		
		$('body').append($modal);
		
		$('#gallery__modal').foundation().on('closed.zf.reveal', function () {
			$('#gallery__modal').remove();
		});
		
		$('#gallery__modal').foundation('open');
		
		$('.gallery__modal-next').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().next(':visible').length > 0 ) { // is the next thumb visible?
				$clickedThumbnail.parent().next(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().nextUntil(':visible').length > 0 ) { // no, so find the next visible one
				$clickedThumbnail.parent().nextAll(':visible').first().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		});
		
		$('.gallery__modal-prev').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().prev(':visible').length > 0 ) { // is the previous thumb visible?
				$clickedThumbnail.parent().prev(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
				$clickedThumbnail.parent().prevAll(':visible').last().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		}); 
		
		return false;
	});
	
	refreshMasonry();
	$('.gallery').on('filter-changed', function () {
		setTimeout(refreshMasonry, 600);
	});
	
	Foundation.onImagesLoaded($('.gallery__item img'), refreshMasonry);
	
	function refreshMasonry() {
		$('.gallery__grid').masonry({
			columnWidth: '.gallery__item-sizer',
			itemSelector: '.gallery__item',
			percentPosition: true,
			horizontalOrder: true
		});
	};
	
	// Remove the transition class after loading to avoid jumpy thumbnails
	setTimeout(function () {
		$('.gallery__item').removeClass('transition--2000');
	}, 2000);
	
	
	
	// Remove empty filter buttons (if not handled by the plugin)
	$('.filter__buttons button').each(function () {
		if ( $(this).text() == '' ) {
			$(this).remove();
		}
	});
}

function initPlainText() {
	var container = $('.plain-text__item');
	if( container.children('plain-text__image').length < 1 ) {
		container.addClass('no-image');
	}
}


function initOffersFilter() {
	var filters = $('.seasonal-landing__filters-inner')
	var selector = $('.selectric-hide-select > select')
	var items = $('.seasonal-landing__item')
	var wrapper = $('.seasonal-landing__grid')
	var dateBtnToAppend = '<button class="button dateFilter hide-for-small-only">Date</button>'
	var dateOptToAppend = '<option class="dateOpt" value="date">Date</option>'
	appendFields();	
	var dateBtn = $('.dateFilter')
	var isDateFilter = false;
	var datedItems = []
	var unDatedItems = []

	function appendFields () {
		if (window.location.pathname === '/offers/' || window.location.pathname === '/T08-Seasonal-Landing.html') {
			filters.prepend(dateBtnToAppend)
			selector.append(dateOptToAppend)
			console.log('by')
		} else {
			return
		}
	}
	

	function setDate(start, end) {
		var startDate = new Date(start)
		var endDate = new Date(end)
		return {
			startDate: startDate,
			endDate: endDate
		}
	}

	function setDateToItems () {
		items.each(function () {
			var startD = $(this).data('startDate')
			var endD = $(this).data('endDate')
			var minDate = '01/01/0001'
			var noStartDate = startD === '' || startD === minDate
			var noEndDate = endD === '' || endD === minDate
			if (noStartDate || noEndDate) {
				unDatedItems.push(($(this)))
			}
			var itemsDate = setDate(startD, endD)
			var datedItem = {
				item: $(this),
				date: itemsDate
			}
			datedItems.push(datedItem)
		})
	}

	function toggleRendering(sortedArr, unDatedArr, orgArr) {
		if (isDateFilter) {
			sortedArr.forEach(function (element) {
				wrapper.append(element.item)
			})
			unDatedArr.forEach(function (element) {
				wrapper.append(element)
			})			
		} else {
			orgArr.each(function () {
				wrapper.append($(this))
			})
		}
	}

	function toggleBtnStyle() {
		if (!isDateFilter) {
			dateBtn.removeClass('on')
		} else {
			dateBtn.addClass('on')
		}
	}
	
	setDateToItems();

	dateBtn.on('click', function () {
		isDateFilter = true
		var sortByDate = datedItems.sort(function (a, b) {
			return a.date.startDate-b.date.startDate
		})
		toggleRendering(sortByDate, unDatedItems, items)
		toggleBtnStyle()
		setTimeout(function () {
			arrangeSeasonalLanding();
		}, 550);
	})



	selector.change(function () {
		if ($(this).val() !== 'date') return;
		isDateFilter = !isDateFilter
		var sortByDate = datedItems.sort(function (a, b) {
			return a.date.startDate-b.date.startDate
		})
		toggleRendering(sortByDate, unDatedItems, items)
		setTimeout(function () {
			arrangeSeasonalLanding();
		}, 550);
	})




	
}


function initOffersPage () {
	var items = $('.offer-filter-item')
	var container = $('.offers__main')
	var seasonToStart = Number(container.data('seasonToStart')) || getSeasonByMonth()



	appendSeason(items)
	sortBySeason(container, items, seasonToStart)

	// coppied from initHome - it has some bugs
	appendIntroColour()
	animateOfferElements()
	// 

	function getSeasonByMonth () {
		var month = new Date().getMonth()
		if ((month >= 0 && month <= 1) || month === 11) return 4
		if (month >= 2 && month <= 4 ) return 1 
		if (month >= 5 && month <= 7 ) return 2 
		if (month >= 8 && month <= 10 ) return 3 
	}
	function appendSeason (items) {
		items.each(function () {
			$(this).addClass('offers__season--' + $(this).data('season'))
		})
	}
	function sortBySeason (container, items, seasonToStart) {
	
		var sortedByOrder = Array.from(items).sort(function(a,b) {
			return Number(a.dataset.order) - Number(b.dataset.order)
		})
	
		var sortedBySeason = []
		sortedByOrder.reverse().forEach(function (el, i, array) {
			if (Number(el.dataset.order) < seasonToStart) {
				sortedBySeason.push(array[i])
				return
			}
			sortedBySeason.unshift(array[i])
		})
		container.append(sortedBySeason)
	}



	function appendIntroColour () {
		if ( $('body').hasClass('template-offers') ) {
			// Set the correct colour for the top part of the page
			if ( $('.offers__season').first().hasClass('offers__season--spring') ) {
				$('.offers').addClass('offers--spring-first');
			} else if ( $('.offers__season').first().hasClass('offers__season--summer') ) {
				$('.offers').addClass('offers--summer-first');
			} else if ( $('.offers__season').first().hasClass('offers__season--autumn') ) {
				$('.offers').addClass('offers--autumn-first');
			} else if ( $('.offers__season').first().hasClass('offers__season--winter') ) {
				$('.offers').addClass('offers--winter-first');
			}
		}
	}	

	function animateOfferElements () {
		animateOffersSeasons();

		function animateOffersSeasons() {
			$('.offers__item').removeClass('hidden');
		}
		
		scaleHomeWave();
		Foundation.onImagesLoaded($('.offers img'), scaleHomeWave);
		$(window).on('resize', function () {
			setTimeout(function () {
				scaleHomeWave();
			}, 400);
		});
		
		rideTheHomeWave();
		setInterval(rideTheHomeWave, 300);
	}
}




// (function (el) {
// 	if (el.dataset.season === 'spring') {
// 		el.dataset.order = 1
// 		return el
// 	}
// 	if (el.dataset.season === 'summer') {
// 		el.dataset.order = 2
// 		return el
// 	}
// 	if (el.dataset.season === 'autumn') {
// 		el.dataset.order = 3
// 		return el
// 	}
// 	if (el.dataset.season === 'winter') {
// 		el.dataset.order = 4
// 		return el
// 	}
// 	return
// })

$('.mini-popup__close').on('click', function () {
	$('.mini-popup-container').hide();
});

$('.header__book .button').on('click', function () {
	$('.mini-popup-container').show();
});

